<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="page_ii"></a>ALSO BY JEANETTE WINTERSON</p>
<p class="textcenter">Oranges Are Not the Only Fruit<br/>Sexing the Cherry<br/>Written on the Body<br/>Art and Lies<br/>Art Objects<br/>Gut Symmetries</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_preface.vue?57b575b8